module.exports = __webpack_public_path__ + "img/promotion_4.89aaee02.png";